import { callApi } from '@local_modules/generic/fetch'

export function addListeners (containerElement) {
  containerElement.addEventListener('click', async (event) => {
    console.log('click', event)
    const target = event.target.closest('[data-action="connect-xero"]')
    if (!target) return

    await loadConsentUrl()
  })
}

async function loadConsentUrl () {
  const apiUrl = '/api/connect-xero/consent-url'

  const apiResponse = await callApi(apiUrl)
  console.log('apiResponse', apiResponse)

  // Redirect to the Xero authentication page
  location.href = apiResponse.consentUrl

  // Actually: redirect can be done from the server (see router-xero-token.js)
}
